<div class="component d-block position-relative full-width full-height">
    <canvas baseChart
            [datasets]="datasets"
            [labels]="lineChartLabels"
            [options]="chartOptions"
            chartType="line">
    </canvas>
</div>
